module.exports = __webpack_public_path__ + "static/media/stats2_1965.419910d4.jpg";